import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import axios from "axios";

const API_BASE_URL = "https://admin.shopaholics.ge/api";

/* ========== THEME ========== */
const UI = {
  pageBg: "#f5f7fb",
  cardBg: "#ffffff",
  text: "#0f172a",
  dim: "#64748b",
  line: "rgba(2,6,23,.08)",
  lineStrong: "rgba(2,6,23,.12)",
  focus: "#2563eb",
  primary: "#0ea5e9",
  success: "#16a34a",
  radius: "14px",
  shadow: "0 10px 28px rgba(2,6,23,.06)",
};

const Wrap = styled.div`
  max-width: 1200px; margin: 0 auto;
  padding: clamp(20px, 4vw, 32px) 16px;
  background: ${UI.pageBg};
`;

const Title = styled.h2`
  font-size: clamp(20px, 2.4vw, 24px);
  font-weight: 800; letter-spacing: .2px; color: ${UI.text};
  text-align: center; margin-bottom: 12px;
`;

const Toolbar = styled.div`
  background: ${UI.cardBg}; border: 1px solid ${UI.line};
  border-radius: ${UI.radius}; box-shadow: ${UI.shadow};
  padding: 12px; display: grid; gap: 10px;
`;

const Filters = styled.div`
  display: grid; grid-template-columns: 1fr 1fr 1fr auto; gap: 10px;
  @media (max-width: 980px){ grid-template-columns: 1fr 1fr; }
  @media (max-width: 620px){ grid-template-columns: 1fr; }
`;

const Input = styled.input`
  width: 100%; padding: 12px 14px; font-size: 15px;
  border: 1px solid ${UI.line}; border-radius: 12px; background: #fff;
  transition: border-color .15s ease, box-shadow .15s ease;
  &:focus { border-color: ${UI.focus}; box-shadow: 0 0 0 3px rgba(37,99,235,.15); outline: none; }
`;

const Button = styled.button`
  padding: 12px 14px; border-radius: 12px; font-weight: 800; font-size: 14px;
  border: 1px solid ${UI.line}; background: ${UI.primary}; color: #fff; cursor: pointer;
  transition: transform .12s ease, filter .15s ease;
  &:hover { filter: brightness(1.05); }
  &:active { transform: translateY(1px); }
`;

const OrdersList = styled.div` margin-top: 14px; display: grid; gap: 14px; `;

const Card = styled.div`
  background: ${UI.cardBg}; border: 1px solid ${UI.line};
  border-radius: ${UI.radius}; box-shadow: ${UI.shadow}; padding: 14px;
`;

const Header = styled.div`
  display: grid; grid-template-columns: 1fr auto; gap: 12px; align-items: center;
`;

const HLeft = styled.div` display:flex; gap:8px; align-items:center; flex-wrap:wrap; `;
const HRight = styled.div` color: ${UI.dim}; font-size: 13px; text-align: right; `;
const Pill = styled.span`
  padding:2px 8px; border-radius:999px; font-size:12px; font-weight:800; color:#fff;
  background:${({done})=>done?UI.success:UI.primary};
`;

const Info = styled.div`
  margin-top: 8px; padding: 10px 12px;
  border:1px dashed ${UI.line}; border-radius: 10px; background: #fafbff; color:${UI.text}; font-size:14px;
`;

const Table = styled.div`
  margin-top: 10px; border:1px solid ${UI.line}; border-radius:12px; overflow:hidden;
`;

const THead = styled.div`
  display:grid; grid-template-columns: 64px 1fr 140px 110px 120px 110px;
  gap:8px; align-items:center; background:#f3f6fb; padding:10px 12px; font-weight:800; font-size:13px; color:${UI.text};
  border-bottom:1px solid ${UI.line};
  @media (max-width: 900px){ grid-template-columns: 56px 1fr 120px 90px 100px 90px; }
  @media (max-width: 720px){ display:none; }
`;

const TRow = styled.div`
  display:grid; grid-template-columns: 64px 1fr 140px 110px 120px 110px;
  gap:8px; align-items:center; padding:10px 12px; border-bottom:1px solid ${UI.line}; background:#fff;
  @media (max-width: 900px){ grid-template-columns: 56px 1fr 120px 90px 100px 90px; }
  @media (max-width: 720px){ grid-template-columns: 1fr; gap:10px; padding:12px; }
  &:last-child{ border-bottom:none; }
`;

const Thumb = styled.img` width:56px; height:56px; object-fit:cover; border-radius:10px; border:1px solid ${UI.line}; background:#fff; `;
const NameBox = styled.div` display:grid; gap:4px; `;
const Name = styled.div` font-weight:800; color:${UI.text}; font-size:14px; `;
const Muted = styled.div` color:${UI.dim}; font-size:12px; `;
const Badge = styled.span` display:inline-block; padding:4px 8px; border-radius:999px; font-size:12px; font-weight:700; background:#eef2ff; color:#334155; border:1px solid ${UI.line}; `;

const Footer = styled.div` margin-top: 10px; display:flex; justify-content:space-between; align-items:center; gap:8px; flex-wrap:wrap; `;
const Total = styled.div` font-size:16px; font-weight:900; color:${UI.text}; `;
const DoneBtn = styled.button`
  padding:10px 14px; border-radius:12px; font-weight:800; font-size:14px;
  border:1px solid ${({disabled})=>disabled?"rgba(22,163,74,.28)":UI.line};
  background:${({disabled})=>disabled?"rgba(22,163,74,.1)":UI.primary}; color:${({disabled})=>disabled?"#14532d":"#fff"};
  cursor:${({disabled})=>disabled?"default":"pointer"};
  transition: transform .12s ease, filter .15s ease;
  &:hover{ filter:${({disabled})=>disabled?"none":"brightness(1.05)"}; }
  &:active{ transform:${({disabled})=>disabled?"none":"translateY(1px)"}; }
`;

/* Gift set breakdown */
const GSCard = styled.div`
  grid-column: 1 / -1;
  margin: 8px 0 4px;
  background:#fafbff; border:1px solid ${UI.line}; border-radius:10px; padding:10px;
`;
const GSTitle = styled.div` font-weight:800; margin-bottom:6px; `;
const GSTable = styled.div` border:1px solid ${UI.line}; border-radius:10px; overflow:hidden; `;
const GSHead = styled.div`
  display:grid; grid-template-columns: 56px 1fr 120px 80px 100px 100px;
  background:#f3f6fb; padding:8px 10px; font-weight:800; font-size:12px;
  border-bottom:1px solid ${UI.line};
  @media (max-width: 720px){ display:none; }
`;
const GSRow = styled.div`
  display:grid; grid-template-columns: 56px 1fr 120px 80px 100px 100px;
  padding:8px 10px; border-bottom:1px solid ${UI.line}; background:#fff;
  @media (max-width: 720px){ grid-template-columns:1fr; gap:8px; padding:10px; }
  &:last-child{ border-bottom:none; }
`;
const SmallThumb = styled.img` width:48px; height:48px; object-fit:cover; border-radius:8px; border:1px solid ${UI.line}; background:#fff; `;

const Pager = styled.div`
  margin-top: 14px; display:flex; justify-content:center; align-items:center; gap:8px; flex-wrap:wrap;
`;
const PageBtn = styled.button`
  padding:8px 12px; border-radius:10px; border:1px solid ${UI.line};
  background:#fff; cursor:pointer; font-weight:700;
  ${({active})=>active && `background:${UI.primary}; color:#fff;`}
`;
const PerPage = styled.select`
  padding:8px 12px; border-radius:10px; border:1px solid ${UI.line};
  background:#fff; font-weight:700;
`;

export default function AllOrders() {
  const [orders, setOrders] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);

  // ძიება — ერთ ველში: order id / email / phone
  const [q, setQ] = useState("");

  const [loading, setLoading] = useState(false);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API_BASE_URL}/get_all_orders.php`, {
        withCredentials: true,
        params: { page, per_page: perPage, q }
      });
      setOrders(data.orders || []);
      setTotalPages(data.total_pages || 1);
      setTotal(data.total || 0);
    } catch (e) {
      console.error("❌ fetch orders:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchOrders(); /* eslint-disable-next-line */ }, [page, perPage]);
  // ძიებაზე Enter ან Search ღილაკი
  const onSearch = () => { setPage(1); fetchOrders(); };

  const markAsDone = async (order_id) => {
    if (!window.confirm("ნამდვილად გსურთ მონიშნოთ დასრულებულად?")) return;
    try {
      const res = await axios.post(`${API_BASE_URL}/update_order_status.php`, { order_id }, { withCredentials: true });
      if (res.data?.success) {
        alert("✅ Order marked as done!");
        fetchOrders();
      } else {
        alert(`❌ Failed to mark as done${res.data?.error ? `: ${res.data.error}` : ""}`);
      }
    } catch (err) {
      console.error("❌ Error updating order:", err);
      alert("❌ An error occurred");
    }
  };

  return (
    <Wrap>
      <Title>ყველა შეკვეთა</Title>

      <Toolbar>
        <Filters>
          <Input
            placeholder="🔎 Order ID / Email / Phone"
            value={q}
            onChange={(e)=>setQ(e.target.value)}
            onKeyDown={(e)=>{ if(e.key==="Enter") onSearch(); }}
          />
          <PerPage value={perPage} onChange={e=>{ setPerPage(Number(e.target.value)); setPage(1); }}>
            {[10,20,30,50,100].map(n=><option key={n} value={n}>{n} / გვერდზე</option>)}
          </PerPage>
          <div />
          <Button onClick={onSearch} style={{justifySelf:'end'}}>ძებნა</Button>
        </Filters>
        <div style={{fontSize:13, color:UI.dim}}>
          {loading ? "იტვირთება…" : `ჯამი: ${total} შეკვეთა • გვერდი ${page}/${totalPages}`}
        </div>
      </Toolbar>

      <OrdersList>
        {orders.length === 0 && !loading && (
          <div style={{ color: UI.dim, textAlign: "center", padding: "14px" }}>🚫 ვერ მოიძებნა ჩანაწერები</div>
        )}

        {orders.map(order => (
          <Card key={order.order_id}>
            <Header>
              <HLeft>
                <div style={{fontWeight:800}}>📦 შეკვეთა #{order.order_id} Public Order Id #{order.public_order_id}</div>
                <Pill done={order.done}>{order.done ? "დასრულებულია" : "გახსნილი"}</Pill>
              </HLeft>
              <HRight>{new Date(order.purchase_date).toLocaleString()}</HRight>
            </Header>

            <Info>
              <strong>👤 მომხმარებელი:</strong>{" "}
              {order.user_name || "—"} &nbsp;|&nbsp; 📧 {order.user_email || "—"} &nbsp;|&nbsp; 📞 {order.user_phone || "—"}
            </Info>

            <Table>
              <THead>
                <div>სურათი</div>
                <div>პროდუქტი</div>
                <div>ID / ტიპი</div>
                <div>რაოდ.</div>
                <div>ფასი (₾)</div>
                <div>ჯამი (₾)</div>
              </THead>

              {order.items.map((it, idx) => {
                const lineTotal = (it.price || 0) * (it.quantity || 0);
                const typeLabel = (it.product_type || "unknown").replaceAll("-", " ");
                const sizePart = it.size ? `ზომა: ${it.size}${it.product_type === "perfume" ? "ml" : ""}` : (it.variant_size ? `ზომა: ${it.variant_size}` : "");
                const colorPart = it.variant_color ? ` • ფერი: ${it.variant_color}` : "";
                return (
                  <React.Fragment key={idx}>
                    <TRow>
                      <div><Thumb src={it.image_url || "/placeholder.jpg"} alt={it.name || "item"} /></div>
                      <NameBox>
                        <Name>{it.name || "სახელის გარეშე"}</Name>
                        <Muted>{[sizePart, colorPart].filter(Boolean).join("")}</Muted>
                      </NameBox>
                      <div>
                        <Badge style={{display:'block'}}>ID: {it.product_id || "—"}</Badge>
                        <div style={{height:6}} />
                        <Badge>{typeLabel}</Badge>
                      </div>
                      <div style={{fontWeight:800}}>×{it.quantity}</div>
                      <div>{(it.price || 0).toFixed(2)}</div>
                      <div style={{fontWeight:800}}>{lineTotal.toFixed(2)}</div>
                    </TRow>

                    {/* Gift set breakdown */}
                    {it.product_type === "gift_set" && it.gift_set?.items?.length > 0 && (
                      <GSCard>
                        <GSTitle>🎁 Gift Set: {it.gift_set.title} — შემადგენლობა</GSTitle>
                        <GSTable>
                          <GSHead>
                            <div>სურათი</div>
                            <div>პროდუქტი</div>
                            <div>ზომა/ფერი</div>
                            <div>რაოდ.</div>
                            <div>ერთ. ფასი</div>
                            <div>ხაზის ჯამი</div>
                          </GSHead>
                          {it.gift_set.items.map((gi, j) => {
                            const gLine = (gi.unit_price || 0) * (gi.quantity || 0);
                            const gSize = gi.ml_size ? `ზომა: ${gi.ml_size}ml` : (gi.variant_size ? `ზომა: ${gi.variant_size}` : "");
                            const gColor = gi.variant_color ? ` • ფერი: ${gi.variant_color}` : "";
                            return (
                              <GSRow key={j}>
                                <div><SmallThumb src={gi.image_url || "/placeholder.jpg"} alt={gi.name || "gs-item"} /></div>
                                <div>
                                  <div style={{fontWeight:800}}>{gi.name || "—"}</div>
                                  <div style={{color:UI.dim, fontSize:12}}>ID: {gi.product_id || "—"}</div>
                                </div>
                                <div style={{fontSize:13, color:UI.dim}}>{[gSize, gColor].filter(Boolean).join("") || "—"}</div>
                                <div style={{fontWeight:800}}>×{gi.quantity}</div>
                                <div>{(gi.unit_price || 0).toFixed(2)}</div>
                                <div style={{fontWeight:800}}>{gLine.toFixed(2)}</div>
                              </GSRow>
                            );
                          })}
                        </GSTable>
                      </GSCard>
                    )}
                  </React.Fragment>
                );
              })}
            </Table>

            <Footer>
              <DoneBtn disabled={order.done} onClick={()=>!order.done && markAsDone(order.order_id)}>
                {order.done ? "✅ დასრულებულია" : "მონიშნე დასრულებულად"}
              </DoneBtn>
              <Total>💵 მთლიანი ფასი: {Number(order.total_price || 0).toFixed(2)} ₾</Total>
            </Footer>
          </Card>
        ))}
      </OrdersList>

      {totalPages > 1 && (
        <Pager>
          <PageBtn onClick={()=> setPage(p=>Math.max(1,p-1))} disabled={page===1}>←</PageBtn>
          {Array.from({length: totalPages}).slice(Math.max(0,page-3), Math.min(totalPages, page+2)).map((_, i) => {
            const p = Math.max(1, page-2) + i;
            if (p > totalPages) return null;
            return <PageBtn key={p} active={p===page} onClick={()=>setPage(p)}>{p}</PageBtn>;
          })}
          <PageBtn onClick={()=> setPage(p=>Math.min(totalPages,p+1))} disabled={page===totalPages}>→</PageBtn>
        </Pager>
      )}
    </Wrap>
  );
}
